import React from "react";
import { SITE } from "../../config/site";
import { AppleMark } from "./ProductIcons";

export default function InkAppCta({
  children = "Get the app",
  inverted = false,
  className = "",
}) {
  return (
    <a
      href={SITE.appStoreUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={[
        "inline-flex min-h-11 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
        inverted
          ? "bg-white text-ink hover:bg-white/90 focus-visible:outline-white"
          : "bg-ink text-white hover:bg-ink/90 focus-visible:outline-ink",
        className,
      ].join(" ")}
    >
      <AppleMark className="h-4 w-4" />
      {children}
      <span aria-hidden="true">↗</span>
    </a>
  );
}
